import { createSlice } from "@reduxjs/toolkit";
import {
  playCoinFlipBuilder,
  playDiceBuilder,
  playRollDiceBuilder,
  playScratchBuilder,
  playSpinBuilder,
  playDropBuilder,
  minesBuilder,
  slotsBuilder,
  bunnyCrashBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const INIT_STATE = {
  coinflipPending: false,
  dicePending: false,
  rollDicePending: false,
  scratchPending: false,
  spinPending: false,
  dropPending: false,
  minesPending: false,
  slotsPending: false,
  bunnyCrashPending: false,
};

export const gamesSlice = createSlice({
  name: "gamesInfo",
  initialState: INIT_STATE,
  reducers: {
    resetGamesState: () => INIT_STATE,
  },
  extraReducers: (builder) => {
    playCoinFlipBuilder(builder);
    playDiceBuilder(builder);
    playRollDiceBuilder(builder);
    playScratchBuilder(builder);
    playSpinBuilder(builder);
    playDropBuilder(builder);
    minesBuilder(builder);
    slotsBuilder(builder);
    bunnyCrashBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const { resetGamesState } = gamesSlice.actions;

export const selectCoinflipPending = (state) => state.gamesInfo.coinflipPending;
export const selectDicePending = (state) => state.gamesInfo.dicePending;
export const selectRollDicePending = (state) => state.gamesInfo.rollDicePending;
export const selectScratchPending = (state) => state.gamesInfo.scratchPending;
export const selectSpinPending = (state) => state.gamesInfo.spinPending;
export const selectDropPending = (state) => state.gamesInfo.dropPending;
export const selectMinesPending = (state) => state.gamesInfo.minesPending;
export const selectSlotsPending = (state) => state.gamesInfo.slotsPending;
export const selectBunnyCrashPending = (state) => state.gamesInfo.bunnyCrashPending;

export default gamesSlice.reducer;
